import React, { createRef } from "react";
import {css} from '@emotion/css';
import * as lodash from 'lodash';
import {hexColorToBright} from '../helper';

export default class Corner extends React.Component {
    resizeObserver = null;
    resizeElement = createRef();

    constructor(props) {
        super(props);
        this.state = {
            initialize: false,
            menu_name: {width: 1, height: 1},
            calories: {width: 1, height: 1},
            food_value_1: {width: 1, height: 1},
            sodium_content: {width: 1, height: 1},
            protein: {width: 1, height: 1},
            lipid: {width: 1, height: 1},
            carbohydrate: {width: 1, height: 1},
            vegetable_weight: {width: 1, height: 1},
            water: {width: 1, height: 1},
            ash: {width: 1, height: 1},
            sodium: {width: 1, height: 1},
            potassium: {width: 1, height: 1},
            calcium: {width: 1, height: 1},
            magnesium: {width: 1, height: 1},
            phosphorous: {width: 1, height: 1},
            iron: {width: 1, height: 1},
            zinc: {width: 1, height: 1},
            copper: {width: 1, height: 1},
            retinol: {width: 1, height: 1},
            carotene: {width: 1, height: 1},
            retinol_equivalent: {width: 1, height: 1},
            vitamin_d: {width: 1, height: 1},
            vitamin_e: {width: 1, height: 1},
            vitamin_k: {width: 1, height: 1},
            vitamin_b1: {width: 1, height: 1},
            vitamin_b2: {width: 1, height: 1},
            niacin: {width: 1, height: 1},
            vitamin_b6: {width: 1, height: 1},
            vitamin_b12: {width: 1, height: 1},
            folic_acid: {width: 1, height: 1},
            pantothenic_acid: {width: 1, height: 1},
            vitamin_c: {width: 1, height: 1},
            saturated_fatty_acids: {width: 1, height: 1},
            monounsaturated_fatty_acids: {width: 1, height: 1},
            polyunsaturated_fatty_acids: {width: 1, height: 1},
            cholesterol: {width: 1, height: 1},
            water_soluble_dietary_fiber: {width: 1, height: 1},
            insoluble_dietary_fiber: {width: 1, height: 1},
            dietary_fiber: {width: 1, height: 1},
            manganese: {width: 1, height: 1},
            food_value_2: {width: 1, height: 1},
            food_value_3: {width: 1, height: 1},
            staple_food: {width: 1, height: 1},
            side_dish: {width: 1, height: 1},
            main_dish: {width: 1, height: 1},
            dairy: {width: 1, height: 1},
            fruit: {width: 1, height: 1},
            egg: {width: 1, height: 1},
            milk: {width: 1, height: 1},
            wheat: {width: 1, height: 1},
            buckwheat: {width: 1, height: 1},
            peanut: {width: 1, height: 1},
            shrimp: {width: 1, height: 1},
            crab: {width: 1, height: 1},
            walnut: {width: 1, height: 1},
            beef: {width: 1, height: 1},
            chicken: {width: 1, height: 1},
            pork: {width: 1, height: 1},
            abalone: {width: 1, height: 1},
            squid: {width: 1, height: 1},
            salmon_roe: {width: 1, height: 1},
            orange: {width: 1, height: 1},
            kiwi_frult: {width: 1, height: 1},
            salmon: {width: 1, height: 1},
            mackerel: {width: 1, height: 1},
            soybean: {width: 1, height: 1},
            matsutake: {width: 1, height: 1},
            peach: {width: 1, height: 1},
            wild_yam: {width: 1, height: 1},
            apple: {width: 1, height: 1},
            gelatin: {width: 1, height: 1},
            banana: {width: 1, height: 1},
            cashew_nut: {width: 1, height: 1},
            sesame: {width: 1, height: 1},
            almond: {width: 1, height: 1},
            seafood: {width: 1, height: 1},
            rice: {width: 1, height: 1},
            spare_allergen_1: {width: 1, height: 1},
            spare_allergen_2: {width: 1, height: 1},
            spare_allergen_2: {width: 1, height: 1},
            header_calories: {width: 1, height: 1},
            header_food_value_1: {width: 1, height: 1},
            header_sodium_content: {width: 1, height: 1},
            header_protein: {width: 1, height: 1},
            header_lipid: {width: 1, height: 1},
            header_carbohydrate: {width: 1, height: 1},
            header_vegetable_weight: {width: 1, height: 1},
            header_water: {width: 1, height: 1},
            header_ash: {width: 1, height: 1},
            header_sodium: {width: 1, height: 1},
            header_potassium: {width: 1, height: 1},
            header_calcium: {width: 1, height: 1},
            header_magnesium: {width: 1, height: 1},
            header_phosphorous: {width: 1, height: 1},
            header_iron: {width: 1, height: 1},
            header_zinc: {width: 1, height: 1},
            header_copper: {width: 1, height: 1},
            header_retinol: {width: 1, height: 1},
            header_carotene: {width: 1, height: 1},
            header_retinol_equivalent: {width: 1, height: 1},
            header_vitamin_d: {width: 1, height: 1},
            header_vitamin_e: {width: 1, height: 1},
            header_vitamin_k: {width: 1, height: 1},
            header_vitamin_b1: {width: 1, height: 1},
            header_vitamin_b2: {width: 1, height: 1},
            header_niacin: {width: 1, height: 1},
            header_vitamin_b6: {width: 1, height: 1},
            header_vitamin_b12: {width: 1, height: 1},
            header_folic_acid: {width: 1, height: 1},
            header_pantothenic_acid: {width: 1, height: 1},
            header_vitamin_c: {width: 1, height: 1},
            header_saturated_fatty_acids: {width: 1, height: 1},
            header_monounsaturated_fatty_acids: {width: 1, height: 1},
            header_polyunsaturated_fatty_acids: {width: 1, height: 1},
            header_cholesterol: {width: 1, height: 1},
            header_water_soluble_dietary_fiber: {width: 1, height: 1},
            header_insoluble_dietary_fiber: {width: 1, height: 1},
            header_dietary_fiber: {width: 1, height: 1},
            header_manganese: {width: 1, height: 1},
            header_food_value_2: {width: 1, height: 1},
            header_food_value_3: {width: 1, height: 1},
            header_staple_food: {width: 1, height: 1},
            header_side_dish: {width: 1, height: 1},
            header_main_dish: {width: 1, height: 1},
            header_dairy: {width: 1, height: 1},
            header_fruit: {width: 1, height: 1},
            header_egg: {width: 1, height: 1},
            header_milk: {width: 1, height: 1},
            header_wheat: {width: 1, height: 1},
            header_buckwheat: {width: 1, height: 1},
            header_peanut: {width: 1, height: 1},
            header_shrimp: {width: 1, height: 1},
            header_crab: {width: 1, height: 1},
            header_walnut: {width: 1, height: 1},
            header_beef: {width: 1, height: 1},
            header_chicken: {width: 1, height: 1},
            header_pork: {width: 1, height: 1},
            header_abalone: {width: 1, height: 1},
            header_squid: {width: 1, height: 1},
            header_salmon_roe: {width: 1, height: 1},
            header_orange: {width: 1, height: 1},
            header_kiwi_frult: {width: 1, height: 1},
            header_salmon: {width: 1, height: 1},
            header_mackerel: {width: 1, height: 1},
            header_soybean: {width: 1, height: 1},
            header_matsutake: {width: 1, height: 1},
            header_peach: {width: 1, height: 1},
            header_wild_yam: {width: 1, height: 1},
            header_apple: {width: 1, height: 1},
            header_gelatin: {width: 1, height: 1},
            header_banana: {width: 1, height: 1},
            header_cashew_nut: {width: 1, height: 1},
            header_sesame: {width: 1, height: 1},
            header_almond: {width: 1, height: 1},
            header_seafood: {width: 1, height: 1},
            header_rice: {width: 1, height: 1},
            header_spare_allergen_1: {width: 1, height: 1},
            header_spare_allergen_2: {width: 1, height: 1},
            header_spare_allergen_2: {width: 1, height: 1},
        }
    }

    // 動的CSS
    cornerColor = () => {
        return css({
            color: this.props.textColor,
            backgroundColor: this.props.bgColor,
        });
    }
    bgColor = () => {
        const bg_color = hexColorToBright(this.props.bgColor, 0.9);
        return css({
            backgroundColor: bg_color,
        });
    }
    borderColor = (top, bottom, left, right) => {
        return css({
            borderColor: 'rgba(0,0,0,0)',
            borderStyle: 'solid',
            borderTopWidth: `${top}px`,
            borderBottomWidth: `${bottom}px`,
            borderLeftWidth: `${left}px`,
            borderRightWidth: `${right}px`,
        });
    }

    componentDidMount() {
        // リサイズ発生時に枠内にテキストが収まるよう、ビューボックスの値を更新するイベント処理を追加
        this.resizeObserver = new ResizeObserver((entries) => {
            if (entries.length > 0) {
                const svg_text = entries[0].target.getElementsByTagName('text');
                if (svg_text.length > 0) {
                    let after_state = lodash.cloneDeep(this.state);
                    for (const st of svg_text) {
                        if (st.id !== 'initialize') {
                            const id = st.id;
                            const rect = st.getBBox();
                            after_state[id].width = Math.ceil(rect.width);
                            after_state[id].height = Math.ceil(rect.height);
                        }
                    }
                    this.setState(after_state);
                }
            }
        });

        if (this.resizeElement.current) {
            this.resizeObserver.observe(this.resizeElement.current);
        }

        // 一部のケースで正常にテキストがリサイズされないケースがあるため、強制的にリサイズを発生させる。
        setTimeout(() => {
            this.setState({initialize: true});
        }, 100);
    }

    componentDidUpdate(prev_props, prev_state) {
        // テキストのみが変更になってもリサイズが発生しないため、テキストに差がある場合はリサイズ処理を実施
        let changed = false;
        const properties = [
            'menu_name',
            'calories',
            'food_value_1',
            'sodium_content',
            'protein',
            'lipid',
            'carbohydrate',
            'vegetable_weight',
            'water',
            'ash',
            'sodium',
            'potassium',
            'calcium',
            'magnesium',
            'phosphorous',
            'iron',
            'zinc',
            'copper',
            'retinol',
            'carotene',
            'retinol_equivalent',
            'vitamin_d',
            'vitamin_e',
            'vitamin_k',
            'vitamin_b1',
            'vitamin_b2',
            'niacin',
            'vitamin_b6',
            'vitamin_b12',
            'folic_acid',
            'pantothenic_acid',
            'vitamin_c',
            'saturated_fatty_acids',
            'monounsaturated_fatty_acids',
            'polyunsaturated_fatty_acids',
            'cholesterol',
            'water_soluble_dietary_fiber',
            'insoluble_dietary_fiber',
            'dietary_fiber',
            'manganese',
            'food_value_2',
            'food_value_3',
            'staple_food',
            'side_dish',
            'main_dish',
            'dairy',
            'fruit',
            'egg',
            'milk',
            'wheat',
            'buckwheat',
            'peanut',
            'shrimp',
            'crab',
            'walnut',
            'beef',
            'chicken',
            'pork',
            'abalone',
            'squid',
            'salmon_roe',
            'orange',
            'kiwi_frult',
            'salmon',
            'mackerel',
            'soybean',
            'matsutake',
            'peach',
            'wild_yam',
            'apple',
            'gelatin',
            'banana',
            'cashew_nut',
            'sesame',
            'almond',
            'seafood',
            'rice',
            'spare_allergen_1',
            'spare_allergen_2',
            'spare_allergen_2',
        ];
        for (const p of properties) {
            if (this.props.acf[p] !== prev_props.acf[p]) {
                changed = true;
            }
        }
        if (changed && this.resizeElement.current) {
            const svg_text = this.resizeElement.current.getElementsByTagName('text');
            if (svg_text.length > 0) {
                let after_state = {};
                for (const st of svg_text) {
                    const id = st.id;
                    const rect = st.getBBox();
                    after_state[id] = {
                        width: Math.ceil(rect.width),
                        height: Math.ceil(rect.height),
                    };
                }
                this.setState(after_state);
            }
        }

        // mount時にcurrentがnullだった場合、こちらで設定する
        if (this.resizeElement.current) {
            this.resizeObserver.observe(this.resizeElement.current);
        }
    }

    componentWillUnmount() {
        // リサイズイベント処理を削除
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    render() {
        const list_top = [];
        const list_bottom = [];
        const non_scroll = this.props.scrollText ? '' : 'nonscroll';
        const non_side = (this.props.isVertical && !this.props.sideVisibled) ? 'nonside' : '';
        const is_vertical = this.props.isVertical ? 'vertical-' : '';
        let price = 0;
        let menu_name = '';

        if (this.props.acf.provide_date) {
            const alt_menu = this.props.acf.stamp_group_3 == '1';
            const nutrients_key = Object.keys(window.cafeteria_base.cafeteria_nutrients);
            const allergy_key = Object.keys(window.cafeteria_base.cafeteria_allergy);
            for (let i = 0; i < nutrients_key.length; i++) {
                const left = i === 0 ? 2 : 1;
                const right = i === nutrients_key.length + 1 ? 2 : 1;
                list_top.push(
                    <div className={`signage-layout-${is_vertical}info-nutrients-line-cell ${this.borderColor(0,1,left,right)}`}>
                        <div className={`signage-layout-${is_vertical}info-nutrients-line-cell-half signage-layout-${is_vertical}info-nutrients-${this.props.layout} ${non_scroll} ${non_side} ${this.cornerColor()}`}>
                            <svg
                                className={`signage-layout-${is_vertical}info-nutrients-text-svg`}
                                viewBox={`0 0 ${this.state[`header_${nutrients_key[i]}`].width} ${this.state[`header_${nutrients_key[i]}`].height}`}
                                preserveAspectRatio="none"
                            >
                                <text id={`header_${nutrients_key[i]}`} x={0} y={0} dominantBaseline="text-before-edge">{window.cafeteria_base.cafeteria_nutrients[nutrients_key[i]].name}</text>
                            </svg>
                        </div>
                        <div className={`signage-layout-${is_vertical}info-nutrients-line-cell-half signage-layout-${is_vertical}info-nutrients-${this.props.layout} ${non_scroll} ${non_side}`}>
                            <svg
                                className={`signage-layout-${is_vertical}info-nutrients-text-svg`}
                                viewBox={`0 0 ${this.state[nutrients_key[i]].width} ${this.state[nutrients_key[i]].height}`}
                                preserveAspectRatio="none"
                            >
                                <text id={nutrients_key[i]} x={0} y={0} dominantBaseline="text-before-edge">{alt_menu ? '－' : Intl.NumberFormat('ja-JP').format(Math.round(this.props.acf[nutrients_key[i]] * (10 ** window.cafeteria_base.cafeteria_nutrients[nutrients_key[i]].round)) / (10 ** window.cafeteria_base.cafeteria_nutrients[nutrients_key[i]].round)) + ' ' + window.cafeteria_base.cafeteria_nutrients[nutrients_key[i]].unit}</text>
                            </svg>
                        </div>
                    </div>
                );
            }

            for (let j = 0; j < allergy_key.length; j++) {
                const left = j === 0 ? 2 : 1;
                const right = j === allergy_key.length + 1 ? 2 : 1;
                list_bottom.push(
                    <div className={`signage-layout-${is_vertical}info-nutrients-line-cell signage-layout-${is_vertical}info-nutrients-line-allergy-text ${this.borderColor(1,0,left,right)}`}>
                        <div className={`signage-layout-${is_vertical}info-nutrients-line-cell-half signage-layout-${is_vertical}info-nutrients-${this.props.layout} ${non_scroll} ${non_side} ${this.props.acf[allergy_key[j]] === '1' && !alt_menu ? this.cornerColor() : ''}`}>
                            <svg
                                className={`signage-layout-${is_vertical}info-nutrients-text-svg`}
                                viewBox={`0 0 ${this.state[`header_${allergy_key[j]}`].width} ${this.state[`header_${allergy_key[j]}`].height}`}
                                preserveAspectRatio="none"
                            >
                                <text id={`header_${allergy_key[j]}`} x={0} y={0} dominantBaseline="text-before-edge">{window.cafeteria_base.cafeteria_allergy[allergy_key[j]].jpn}</text>
                            </svg>
                        </div>
                        <div className={`signage-layout-${is_vertical}info-nutrients-line-cell-half signage-layout-${is_vertical}info-nutrients-${this.props.layout} ${non_scroll} ${non_side} ${this.props.acf[allergy_key[j]] === '1' && !alt_menu ? this.cornerColor() : ''}`}>
                            <svg
                                className={`signage-layout-${is_vertical}info-nutrients-text-svg`}
                                viewBox={`0 0 ${this.state[allergy_key[j]].width} ${this.state[allergy_key[j]].height}`}
                                preserveAspectRatio="none"
                            >
                                <text id={allergy_key[j]} x={0} y={0} dominantBaseline="text-before-edge">{window.cafeteria_base.cafeteria_allergy[allergy_key[j]].eng}</text>
                            </svg>
                        </div>
                    </div>
                );
            }

            price = this.props.tax === 'in_tax_price' ? this.props.acf.in_tax_price : this.props.acf.ex_tax_price;
            if (this.props.acf.stamp_group_3 !== '1') {
                menu_name = this.props.acf.menu_name;
            }
        }

        return (
            <div className={this.props.className}>
                {
                    (this.props.acf.provide_date || this.props.imgUrl !== '') &&
                    <React.Fragment>
                        {
                            list_top.length === 0 &&
                            <div className={`signage-layout-${is_vertical}alternative-img`}>
                                <img className="menu-img" src={this.props.imgUrl} />
                            </div>
                        }
                        {
                            list_top.length > 0 &&
                            <React.Fragment>
                                <div className={`signage-layout-${is_vertical}img`}>
                                    <img
                                        className="menu-img"
                                        src={this.props.imgUrl}
                                        onError={(e) => {e.target.src = window.cafeteria_path.template_url + '/img/no_image.svg'}}
                                    />
                                    {
                                        this.props.acf.stamp_group_3 === '1' &&
                                        <React.Fragment>
                                            <div className={`signage-layout-${is_vertical}stamp-alternative`}>
                                                <img
                                                    className={`signage-layout-${is_vertical}stamp-alternative-img`}
                                                    src={window.cafeteria_path.template_url + '/img/alternative.svg'}
                                                />
                                            </div>
                                        </React.Fragment>
                                    }
                                    {
                                        this.props.acf.stamp_group_1 === '1' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-left-top-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-rotate`}
                                            src={window.cafeteria_path.template_url + '/img/new.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_1 === '2' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-left-top-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-rotate`}
                                            src={window.cafeteria_path.template_url + '/img/event.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_1 === '3' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-left-top-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-rotate`}
                                            src={window.cafeteria_path.template_url + '/img/pick_up.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_1 === '4' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-left-top-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-breathing`}
                                            src={window.cafeteria_path.template_url + '/img/vegetable.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_1 === '5' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-left-top-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-breathing`}
                                            src={window.cafeteria_path.template_url + '/img/low_sodium.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_1 === '6' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-left-top-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-breathing`}
                                            src={window.cafeteria_path.template_url + '/img/calorie.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_1 === '7' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-left-top-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-breathing`}
                                            src={window.cafeteria_path.template_url + '/img/carbs_off.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_4 === '1' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-right-top-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-scale`}
                                            src={window.cafeteria_path.template_url + '/img/half_size.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_4 === '2' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-right-top-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-scale`}
                                            src={window.cafeteria_path.template_url + '/img/mini_size.svg'}
                                        />
                                    }
                                    {
                                        this.props.stampGroup5 === 'a1' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-left-bottom-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-scale`}
                                            src={window.cafeteria_path.template_url + '/img/garlic.svg'}
                                        />
                                    }
                                    {
                                        /^b/.test(this.props.stampGroup5) &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-left-bottom-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-scale`}
                                            src={window.cafeteria_path.template_url + '/img/hot_' + this.props.stampGroup5.substr(1) + '.svg'}
                                        />
                                    }
                                    {
                                        /^c/.test(this.props.stampGroup5) &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-left-bottom-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-vibration`}
                                            src={window.cafeteria_path.template_url + '/img/wait_' + this.props.stampGroup5.substr(1) + '.svg'}
                                        />
                                    }
                                    {
                                        /^d/.test(this.props.stampGroup5) &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-left-bottom-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-scale`}
                                            src={window.cafeteria_path.template_url + '/img/last_' + this.props.acf.stamp_group_5.substr(1) + '.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_2 === '1' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-right-bottom-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-scale`}
                                            src={window.cafeteria_path.template_url + '/img/just_a_minute_please.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_2 === '2' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-right-bottom-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-scale`}
                                            src={window.cafeteria_path.template_url + '/img/sold_out_soon.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_2 === '4' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-right-bottom-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-scale`}
                                            src={window.cafeteria_path.template_url + '/img/1f_sales.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_2 === '5' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-right-bottom-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-scale`}
                                            src={window.cafeteria_path.template_url + '/img/left_corner.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_2 === '6' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-right-bottom-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-scale`}
                                            src={window.cafeteria_path.template_url + '/img/front_corner.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_2 === '7' &&
                                        <img
                                            className={`signage-layout-${is_vertical}stamp-right-bottom-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-scale`}
                                            src={window.cafeteria_path.template_url + '/img/right_corner.svg'}
                                        />
                                    }
                                    {
                                        this.props.acf.stamp_group_2 === '3' &&
                                        <React.Fragment>
                                            <div className={`signage-layout-${is_vertical}stamp-sold-out`}></div>
                                            <img
                                                className={`signage-layout-${is_vertical}stamp-right-bottom-${this.props.layout} ${non_scroll} ${non_side} stamp-img signage-layout-${is_vertical}stamp-scale`}
                                                src={window.cafeteria_path.template_url + '/img/sold_out.svg'}
                                            />
                                        </React.Fragment>
                                    }
                                </div>
                                <div className={`signage-layout-${is_vertical}info ${!this.state.initialize ? 'initialize' : ''}`}>
                                    <div className={this.cornerColor() + ` signage-layout-${is_vertical}info-corner-${this.props.layout}`}>{this.props.cornerLabel}</div>
                                    <div className={`signage-layout-${is_vertical}info-nutrients ` + this.bgColor()}
                                        ref={this.resizeElement}
                                    >
                                        <div className={`signage-layout-${is_vertical}info-nutrients-line-1`}>
                                            <div
                                                className={`signage-layout-${is_vertical}info-nutrients-line-menu-name signage-layout-${is_vertical}info-nutrients-${this.props.layout}-menu ${non_scroll} ${non_side}`}
                                                
                                            >
                                                <svg
                                                    className={`signage-layout-${is_vertical}info-nutrients-line-menu-name-svg`}
                                                    viewBox={`0 0 ${this.state.menu_name.width} ${this.state.menu_name.height}`}
                                                    preserveAspectRatio="none"
                                                >
                                                    <text
                                                        id="menu_name"
                                                        x={0}
                                                        y={0}
                                                        dominantBaseline="text-before-edge"
                                                    >
                                                        {menu_name}
                                                    </text>
                                                </svg>
                                            </div>
                                            <div className={`signage-layout-${is_vertical}info-nutrients-line-price signage-layout-${is_vertical}info-nutrients-${this.props.layout}-menu ${non_scroll} ${non_side}`}>
                                                {
                                                    this.props.acf.stamp_group_3 === '1' &&
                                                    <React.Fragment>代替メニュー提供中</React.Fragment>
                                                }
                                                {
                                                    this.props.acf.stamp_group_3 !== '1' &&
                                                    <React.Fragment>
                                                        {
                                                            this.props.tax === 'in_tax_price' &&
                                                            <span className={`signage-layout-${is_vertical}info-nutrients-${this.props.layout} ${non_scroll} ${non_side}`}>税込</span>
                                                        }
                                                        {Intl.NumberFormat('ja-JP').format(price)}
                                                        {
                                                            this.props.tax === 'in_tax_price' &&
                                                            <span className={`signage-layout-${is_vertical}info-nutrients-${this.props.layout} ${non_scroll} ${non_side}`}>円</span>
                                                        }
                                                        {
                                                            this.props.tax !== 'in_tax_price' &&
                                                            <span className={`signage-layout-${is_vertical}info-nutrients-${this.props.layout} ${non_scroll} ${non_side}`}>円＋税</span>
                                                        }
                                                    </React.Fragment>
                                                }
                                            </div>
                                        </div>
                                        <div className={`signage-layout-${is_vertical}info-nutrients-line-2`}>
                                            {list_top}
                                        </div>
                                        <div className={`signage-layout-${is_vertical}info-nutrients-line-3`}>
                                            {list_bottom}
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                    </React.Fragment>
                }
            </div>
        );
    }
}